namespace TabAurous.Stock {
    export namespace StockItemService {
        export const baseUrl = 'Stock/StockItem';

        export declare function Create(request: Serenity.SaveRequest<StockItemRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<StockItemRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function StockGroupList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetStockTransactions(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomMaterialOutList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductDetails(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SalesReturnList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductHistory(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CheckTransaction(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CheckItemTransaction(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetWeightedAVGRate(request: ProductRequest, onSuccess?: (response: Common.AVGRateResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetOrderStock(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetReturnValues(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Stock/StockItem/Create",
            Update = "Stock/StockItem/Update",
            Delete = "Stock/StockItem/Delete",
            Retrieve = "Stock/StockItem/Retrieve",
            List = "Stock/StockItem/List",
            CustomList = "Stock/StockItem/CustomList",
            StockGroupList = "Stock/StockItem/StockGroupList",
            GetStockTransactions = "Stock/StockItem/GetStockTransactions",
            CustomMaterialOutList = "Stock/StockItem/CustomMaterialOutList",
            GetProductDetails = "Stock/StockItem/GetProductDetails",
            SalesReturnList = "Stock/StockItem/SalesReturnList",
            ProductHistory = "Stock/StockItem/ProductHistory",
            CheckTransaction = "Stock/StockItem/CheckTransaction",
            CheckItemTransaction = "Stock/StockItem/CheckItemTransaction",
            GetWeightedAVGRate = "Stock/StockItem/GetWeightedAVGRate",
            GetOrderStock = "Stock/StockItem/GetOrderStock",
            GetReturnValues = "Stock/StockItem/GetReturnValues"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'StockGroupList', 
            'GetStockTransactions', 
            'CustomMaterialOutList', 
            'GetProductDetails', 
            'SalesReturnList', 
            'ProductHistory', 
            'CheckTransaction', 
            'CheckItemTransaction', 
            'GetWeightedAVGRate', 
            'GetOrderStock', 
            'GetReturnValues'
        ].forEach(x => {
            (<any>StockItemService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
